import styled from 'styled-components'
import { backgroundBlue, blue, blueDark, white } from '@/theme/colors'
import { media } from '@/theme/tokens'
import { fontSizes, text } from '@/theme/typography'
import { Checkbox } from '@components/Field'

/** Sidebar beside content; the sidebar becomes an overlay drawer on narrow screens. */
export const AdminContainer = styled.div`
	display: flex;
	height: 100%;
	overflow: hidden;
	background-color: ${backgroundBlue};
`

/** The content column: a fixed filter bar above a scrolling body. */
export const AdminMain = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
	min-width: 0;
	overflow: hidden;
`

/**
 * The global filters, directly above the content they scope. Keeps the admin
 * nav's dark treatment so the two read as one chrome, and holds the drawer
 * toggle on narrow screens.
 */
export const FilterBar = styled.div`
	display: flex;
	align-items: center;
	gap: 16px;
	padding: 0 24px;
	min-height: 56px;
	flex-shrink: 0;
	background-color: ${blueDark};
	color: ${white};

	${media.tabletWide} {
		padding: 10px 14px;
		gap: 12px;
		flex-wrap: wrap;
	}
`

export const AdminContent = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 32px 24px;

	${media.phone} {
		padding: 16px 14px;
	}
`

export const AdminHeading = styled.h1`
	margin: 0 0 24px;
	${text.display}
	color: ${blue};
`

export const InternalToggle = styled.label`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	color: ${white};
	font-size: ${fontSizes.small};
	font-weight: 500;
	white-space: nowrap;
	cursor: pointer;
	user-select: none;
`

/** The Field checkbox, in white on the sidebar's dark ground. */
export const InternalCheckbox = styled(Checkbox)`
	accent-color: ;
`
